<template>
    <!-- 公共底部 go -->
    <div>
        <div class="gg_dbtab">
            <div class="gg_dbtab_n">
                <div class="gg_dbtab_t"><img src="@/assets/img/foo.png" /></div>
                <div class="gg_dbtab_b">
                    <a><img src="@/assets/img/foo5.png" /></a>
                    <a><img src="@/assets/img/foo2.png" /></a>
                    <a><img src="@/assets/img/foo3.png" /></a>
                    <!-- <a href="https://www.xinzhiyukeji.cn/" target="_blank" class="xzyLogo"><img
                            src="@/assets/img/foo4.png" /></a> -->
                </div>
            </div>
        </div>
        <div class="gg_footer">
            <img src="@/assets/img/icon4.png" class="gg_footer_zsl" />
            <img src="@/assets/img/icon4.png" class="gg_footer_zsr" />
            <div class="gg_footer_n">
                <div class="gg_footer_l">
                    <!-- <div class="gg_footer_l_a">Vectory</div>
                    <div class="gg_footer_l_b">Subscribe to Vectory</div>
                    <div class="gg_footer_l_c"><input type="text" v-model="emailData"
                            placeholder="Please enter your email" />
                        <p @click="submitHandle">Subscribe</p>
                    </div> -->
                </div>
                <div class="gg_footer_r">
                    <div class="gg_footer_r_li">
                        <p>About Vectory</p>
                        <div><a href="https://vectory-space.gitbook.io/vectory-space/">White Paper</a></div>
                        <div><a href="">About Us</a></div>
                        <div><a href="">Privacy</a></div>
                        <div><a href="">Terms of Use</a></div>
                    </div>
                    <div class="gg_footer_r_li">
                        <p>Contact Us</p>
                        <div><a href="">Email:contact@vectory.space</a></div>
                        <!-- <div><a href="">Partnership</a></div>
                        <div><a href="">Investment</a></div> -->
                    </div>
                </div>
            </div>
            <div v-if="ifameShow" class="iframeBox">
                <iframe  src="https://vectory.substack.com/embed" width="100%" height="100%"
                    style="border:1px solid #EEE; background:white;" frameborder="0" scrolling="no"></iframe>
            </div>
        </div>

    </div>
    <!-- 公共底部 end -->
</template>

<script>
import { Email } from '@/api/user'
export default {
    data() {
        return {
            emailData: '',
            userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
            ifameShow: false
        }
    },
    methods: {
        submitHandle() {
            if (!this.userInfo.id) {
                return this.$message({
                    message: 'Please login in first',
                    type: 'warning'
                })
            }
            // if (!this.emailData) {
            //     return this.$message({
            //         message: 'Please enter your email address',
            //         type: 'warning'
            //     })
            // }
            this.ifameShow = true
            // Email({ content: this.emailData }).then(res => {
            //     if (res.code == 1) {
            //         this.$message({
            //             message: res.msg,
            //             type: 'success'
            //         });
            //     } else {
            //         this.$message({
            //             message: res.msg,
            //             type: 'warning'
            //         });
            //     }
            // })
        }
    }
}
</script>

<style lang="scss">
.bottom-nav {
    width: 100%;
    display: flex;
}

.iframeBox {
    width: 680px;
    height: 320px;
    position: absolute;
    bottom: 5%;
    left: 10%;
    z-index: 1000;
}
@media screen and (max-width: 1060px) {
    .iframeBox {
        width: 540px;
        height: 320px;
        position: absolute;
        bottom: 0%;
        left: 0%;
        z-index: 1000;
    }
}
@media screen and (max-width: 750px) {
    .iframeBox {
        width: 360px;
        height: 170px;
        position: absolute;
        bottom: 55%;
        left: 5%;
        z-index: 1000;
    }
}

.left-title {
    font-size: 60px;
    font-weight: 900;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
}

.left-text {
    font-size: 30px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
}

.center-title {
    font-size: 40px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    margin-right: 100px;
}

.right-title {
    font-size: 40px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
}

.center-text {
    font-size: 20px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    text-align: left;
}

.bottom-nav {
    height: auto;
    padding: 82px 200px 40px 200px;
    box-sizing: border-box;
    justify-content: space-between;
}

.left {
    padding-top: 25px;
    box-sizing: border-box;
}

.bottom-nav-r {
    display: flex;
}

// @media (min-width: 1920px) {

// }
@media screen and (max-width:1450px) {
    .bottom-nav {
        padding: 82px 100px 40px 100px;
    }
}

@media screen and (max-width:1280px) {
    .bottom-nav {
        height: auto;
        padding: 82px 60px 40px 60px;
        box-sizing: border-box;
    }

    .left {
        margin-right: 125px !important;
        padding-top: 25px;
        box-sizing: border-box;
    }

    .left-title {
        font-size: 30px;
    }

    .left-text {
        margin: 20px 0 50px 0;
        font-size: 22px;
    }

    .center-title {
        font-size: 20px;
        text-align: left;
    }

    .center-text {
        font-size: 18px;
    }

    .right-title {
        font-size: 20px;
        text-align: left;
    }
}


@media screen and (max-width: 750px) {
    .bottom-nav {
        flex-wrap: wrap !important;
        padding: 20px 20px;
    }

    .left {
        width: 100%;
        margin: 20px auto !important;
    }

    .input-box {
        width: 243px !important;
        margin: auto;
    }

    .center {
        margin-left: 40px !important;
    }

    .left-title {
        font-size: 20px !important;

    }

    .left-text {
        font-size: 10px !important;
        margin: 20px 0 20px 0;

    }

    .center-title {
        font-size: 14px !important;
        margin-right: 100px !important;
    }

    .right-title {
        font-size: 14px !important;
    }

    .center-text {
        font-size: 8px !important;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
    }

    .bottom-nav-r {
        margin: auto;
    }
}
</style>